import React from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { getLooseProducts, removeLooseProduct } from 'helpers/budgetItems';
import { moneyFormat } from 'helpers/moneyFormat';
import { ItemRow, palette, SoftPanel } from '../../components/GuidedSurgerie';
import { useNewSurgerie } from '../../hooks/useNewSurgerie';

const LooseProductsPanel: React.FC = () => {
  const { surgerie, handleChangePackages } = useNewSurgerie();
  const products = getLooseProducts(surgerie.packages);

  if (products.length === 0) return null;

  const total = products.reduce((sum, item) => sum + item.quantity * (item.unit_value || 0), 0);

  return (
    <SoftPanel>
      <Typography variant="body2" fontSize={16} fontWeight={700} color={palette.ink} sx={{ mb: 1 }}>
        Produtos avulsos
      </Typography>

      {products.map((item, index) => (
        <ItemRow key={`${item.product_id}-${index}`}>
          <div>
            <Typography variant="body2">{item.product?.name}</Typography>
            <Typography variant="caption" color="textSecondary">
              {item.quantity} {item.product?.unit} × {moneyFormat(item.unit_value || 0)}
            </Typography>
          </div>
          <Typography variant="body2" fontWeight={700} color="success.main">
            {moneyFormat(item.quantity * (item.unit_value || 0))}
          </Typography>
          <Tooltip title="Remover produto">
            <IconButton
              size="small"
              color="error"
              onClick={() => handleChangePackages(removeLooseProduct(surgerie.packages, index))}
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Tooltip>
        </ItemRow>
      ))}

      <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1, textAlign: 'right' }}>
        Total dos avulsos: <b>{moneyFormat(total)}</b>
      </Typography>
    </SoftPanel>
  );
};

export default LooseProductsPanel;
